
export default function Header() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="px-6 py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/16bc9533d1fb7c21d8b86a1aa65053e9/c32bedfeacbc58798bd6a680fa348e8e.jfif" 
              alt="Concierge & DPC Growth Network" 
              className="h-12 w-auto"
            />
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('how-it-works')}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer"
            >
              How It Works
            </button>
            <button 
              onClick={() => scrollToSection('pricing')}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer"
            >
              Pricing
            </button>
            <a
              href="https://www.facebook.com/profile.php?id=61581793401421"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-orange-500 text-blue-700 px-6 py-2 rounded-lg hover:bg-orange-600 transition-colors font-medium whitespace-nowrap cursor-pointer"
            >
              View Leads On Facebook
            </a>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
            >
              Get Started
            </button>
          </div>

          <div className="md:hidden">
            <button className="text-gray-700 hover:text-blue-600 cursor-pointer">
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
}
